import api from './axios';

export interface MaterialPurchase {
  id?: number;
  materialType: string;
  quantityKg: number;
  unitPrice: number;
  totalPrice?: number;
  supplier?: string;
  notes?: string;
  purchasedAt?: string;
}

export interface OfferMaterials {
  offerId: number;
  orderNo: string;
  needed: Record<string, number>;
  linked: Record<string, number>;
  progress: Record<string, number>;
  overallProgress: number;
  purchases: MaterialPurchase[];
}

export interface MaterialDashboardItem {
  offerId: number;
  orderNo: string;
  customerName: string;
  currency: string;
  needed: Record<string, number>;
  linked: Record<string, number>;
  overallProgress: number;
  materialsLinked: boolean;
  purchases: MaterialPurchase[];
}

export const getOfferMaterials = (offerId: number) =>
  api.get<OfferMaterials>(`/materials/offer/${offerId}`).then(r => r.data);

export const savePurchase = (offerId: number, purchase: MaterialPurchase) =>
  api.post<{purchase: MaterialPurchase; excessKg: number | null; excessMessage: string | null}>(`/materials/offer/${offerId}`, purchase).then(r => r.data);

export const deletePurchase = (purchaseId: number) =>
  api.delete(`/materials/${purchaseId}`);

export const getMaterialsDashboard = () =>
  api.get<MaterialDashboardItem[]>('/materials/dashboard').then(r => r.data);

export const getInventory = () =>
  api.get<Record<string, number>>('/materials/inventory').then(r => r.data);

export interface InventoryDetail {
  quantityKg: number;
  avgUnitPrice: number;
}

export const getInventoryDetail = () =>
  api.get<Record<string, InventoryDetail>>('/materials/inventory/detail').then(r => r.data);

export const addToInventoryDirect = (data: {
  materialType: string; quantityKg: number;
  unitPrice?: number; supplier?: string; notes?: string;
}) => api.post<{message: string; totalStock: number}>('/materials/inventory', data).then(r => r.data);

export interface InventoryHistoryItem {
  id: number;
  materialType: string;
  quantityKg: number;
  unitPrice: number | null;
  source: string;
  notes: string | null;
  createdAt: string;
  offerOrderNo: string | null;
}

export const getInventoryHistory = () =>
  api.get<InventoryHistoryItem[]>('/materials/inventory/history').then(r => r.data);

export const deleteInventoryItem = (id: number) =>
  api.delete(`/materials/inventory/${id}`);

export interface PurchaseArchiveItem {
  id: number;
  materialType: string;
  quantityKg: number;
  unitPrice: number;
  totalPrice: number | null;
  supplier: string | null;
  notes: string | null;
  purchasedAt: string;
  createdAt: string;
  offerOrderNo: string | null;
  offerId: number | null;
  source: string;
}

export const getAllPurchases = () =>
  api.get<PurchaseArchiveItem[]>('/materials/purchases/all').then(r => r.data);

export const addFromInventory = (offerId: number, materialType: string, quantityKg: number) =>
  api.post<{message: string; remainingStock: number}>(`/materials/offer/${offerId}/from-inventory`, { materialType, quantityKg }).then(r => r.data);
